export default __webpack_public_path__ + "static/media/logo.a8f8f3f4.svg";